import { ModelBase } from '../../core/model/model-base';

export enum IndexSeries {
  KPI1980 = 0,
  KPI2020 = 1  
}

export class IndexClauseSettings extends ModelBase {
  constructor(context?: any) {
    super();
    this.indexSeries = IndexSeries.KPI2020;
    this.fromBaseIndex = true;
    this.allowLowerThanBaseIndex = false;

    if (context) {
      this.id = context.id ?? context.Id;
      this.caption = context.caption ?? context.Caption;
      this.fromBaseIndex = context.fromBaseIndex ?? context.FromBaseIndex;
      this.minPercentageChange = context.minPercentageChange ?? context.MinPercentageChange;
      this.maxPercentageChange = context.maxPercentageChange ?? context.MaxPercentageChange;
      this.allowLowerThanBaseIndex = context.allowLowerThanBaseIndex ?? context.AllowLowerThanBaseIndex;
      this.percentageChangeRounding = context.percentageChangeRounding ?? context.PercentageChangeRounding;
      this.indexSeries = context.indexSeries ?? context.IndexSeries ?? IndexSeries.KPI2020;
    }
  }

  caption: string;
  fromBaseIndex: boolean;
  allowLowerThanBaseIndex: boolean;
  minPercentageChange: number | null;
  maxPercentageChange: number | null;
  percentageChangeRounding: number | null;
  indexSeries: IndexSeries;

  get minPercentageChangeText(): string {
    return this._formatPercentageChangeLimit(this.minPercentageChange);
  }

  get maxPercentageChangeText(): string {
    return this._formatPercentageChangeLimit(this.maxPercentageChange);
  }

  get percentageChangeRoundingText(): string {
    return this.percentageChangeRounding === null || this.percentageChangeRounding === undefined
      ? 'INDEX_CLAUSE_SETTINGS.ROUNDING.NONE'
      : this.percentageChangeRounding.toString();
  }

  get indexSeriesText(): string {
    return this.indexSeries === IndexSeries.KPI2020
      ? 'INDEX_CLAUSE_SETTINGS.INDEX_SERIES.KPI2020'
      : 'INDEX_CLAUSE_SETTINGS.INDEX_SERIES.KPI1980';
  }

  get calculationBasisText(): string {
    return this.fromBaseIndex
      ? 'INDEX_CLAUSE_SETTINGS.FROM_BASE_INDEX'
      : 'INDEX_CLAUSE_SETTINGS.FROM_CURRENT_INDEX';
  }

  toString() {
    return this.caption || '';
  }

  private _formatPercentageChangeLimit(value: number | null | undefined): string {
    return value === null || value === undefined ? 'INDEX_CLAUSE_SETTINGS.NO_LIMIT' : value.toString();
  }

  toJSON() {
    return {
      id: this.id,
      caption: this.caption,
      fromBaseIndex: this.fromBaseIndex,
      minPercentageChange: this.minPercentageChange,
      maxPercentageChange: this.maxPercentageChange,
      allowLowerThanBaseIndex: this.allowLowerThanBaseIndex,
      percentageChangeRounding: this.percentageChangeRounding,
      indexSeries: this.indexSeries,
    };
  }
}
